import { Table, Form, Card, Col, Row, Button, Typography, Popover } from 'antd';
import { InfoCircleOutlined, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';

import { useEgresadoContext } from './../../../context/EgresadoProvident';
import useHabilidades from './hookHabilidades';

import EditableCell from './EditableCell';
import ActionsColumn from './ActionsColumn';

const { Title } = Typography;

const Habilidades = ({ id }) => {
    const [form] = Form.useForm();
    const { alumno } = useEgresadoContext();

    const {
        habilidadesBlandas,
        habilidadesTecnicas,
        editingKey,
        isEditing,
        startEdit,
        cancelEdit,
        saveRecord,
        deleteRecord,
        addRecord,
        loading
    } = useHabilidades(alumno?.habilidades);

    const handleEdit = (record) => {
        form.setFieldsValue({ habilidad: '', ...record });
        startEdit(record);
    };

    const handleSave = async (record) => {
        try {
            const values = await form.validateFields();
            await saveRecord({ ...record, ...values });
        } catch (errInfo) {
            //console.log('Validate Failed:', errInfo);
        }
    };

    const handleCancel = async () => {
        cancelEdit();
    };

    const handleAdd = (tipo) => {
        if (addRecord(tipo)) {
            form.setFieldsValue({ habilidad: '', tipo_habilidad: tipo });
        }
    };

    const columns = [
        {
            title: 'Habilidad',
            dataIndex: 'habilidad',
            width: '80%',
            editable: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'acciones',
            render: (_, record) => (
                <ActionsColumn
                    record={record}
                    isEditing={isEditing}
                    onSave={handleSave}
                    onCancel={handleCancel}
                    onEdit={handleEdit}
                    onDelete={deleteRecord}
                    disabled={editingKey !== ''}
                />
            ),
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) return col;
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <Row gutter={[16, 16]} id={id}>

            <Col span={24}>
                <HabilidadesContainer
                    title="Habilidades blandas"
                    content={
                        <div style={{ textAlign: 'justify' }}>
                            "Competencias interpersonales y de personalidad que te ayudan a trabajar bien con otros. Ejemplo: comunicación, liderazgo, adaptabilidad, trabajo en equipo."
                        </div>
                    }
                    tipo_habilidad="BLANDAS"
                    data={habilidadesBlandas}
                    loading={loading}
                    editingKey={editingKey}
                    handleAdd={handleAdd}
                    form={form}
                    mergedColumns={mergedColumns}
                />
            </Col>

            <Col span={24}>
                <HabilidadesContainer
                    title="Habilidades técnicas"
                    content={
                        <div style={{ textAlign: 'justify' }}>
                            Conocimientos específicos y prácticos aplicados en tu trabajo. Ejemplo: programación, manejo de Excel, análisis de datos, etc.
                        </div>
                    } 
                    tipo_habilidad="TECNICAS"
                    data={habilidadesTecnicas}
                    loading={loading}
                    editingKey={editingKey}
                    handleAdd={handleAdd}
                    form={form}
                    mergedColumns={mergedColumns}
                />
            </Col>
        </Row>
    );
};

const HabilidadesContainer = ({ title, content, tipo_habilidad, editingKey, data, loading, handleAdd, form, mergedColumns }) => {
    return (
        <Card>
            <Row justify="space-between" align="middle">
                <Col>
                    <Popover styles={{ root: { width: 250 } }} title={title} content={content} placement="right" icon={<InfoCircleOutlined />}>
                        <Title level={5} strong>{title} <QuestionCircleOutlined /> </Title>
                    </Popover >
                </Col>
                <Col>
                    <Button
                        type="text"
                        style={{ color: '#7c0433' }}
                        icon={<PlusOutlined />}
                        onClick={() => handleAdd(tipo_habilidad)}
                        disabled={editingKey !== ''}
                    >
                        Agregar {title?.toLowerCase()}
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form form={form} component={false}>
                        <Table
                            rowKey='id_habilidad'
                            showHeader={false}
                            loading={loading}
                            size="small"
                            components={{ body: { cell: EditableCell } }}
                            bordered
                            dataSource={data}
                            pagination={{ position: ['bottomRight'], pageSize: 5 }}
                            columns={mergedColumns}
                            rowClassName="editable-row"
                        />
                    </Form>
                </Col>
            </Row>
        </Card>
    );
};

export default Habilidades;